export default __webpack_public_path__ + "static/media/WS.abb53c7e.svg";